import type { ReactNode } from 'react'

import type { Interpolation, Theme } from '@emotion/react'
import { useTheme } from '@emotion/react'

import * as styles from './layout.styles'

type Props = {
  children: ReactNode
  variant: keyof ReturnType<typeof styles.variants>
  align?: keyof typeof styles.align
  className?: string
  css?: Interpolation<Theme>
  grayBackground?: boolean
  isAppBarFixed?: boolean
  justify?: keyof typeof styles.justify
  direction?: keyof typeof styles.direction
  smallerPadding?: boolean
  screenWithAppBar?: boolean
  withinCustomerLayout?: boolean
}

export const Layout = ({
  children,
  variant,
  align = 'default',
  className,
  css: cssProp,
  grayBackground = false,
  isAppBarFixed = false,
  justify = 'default',
  direction = 'default',
  smallerPadding = false,
  screenWithAppBar = true,
  withinCustomerLayout = false,
}: Props) => {
  const theme = useTheme()
  const layoutCss = [
    styles.root,
    styles.variants(theme)[variant],
    variant !== 'screen' && styles.column,
    isAppBarFixed && styles.fixedAppBarMargin,
    smallerPadding && styles.smallerPadding(theme),
    screenWithAppBar && variant === 'screen' && styles.screenHeightWithAppBar,
    withinCustomerLayout && variant === 'screen' && styles.withinCustomerLayout(theme),
    styles.justify[justify],
    styles.align[align],
    styles.direction[direction],
    grayBackground && styles.grayBackground(theme),
    cssProp,
  ]

  return (
    <div className={className} css={layoutCss} data-testid="layout">
      {children}
    </div>
  )
}
